import { useContext } from 'react';
import { ChartContext } from './ChartContext';

// Custom hook to use the chart context
export const useChartContext = () => useContext(ChartContext);

export default useChartContext;
